module.exports = __webpack_public_path__ + "plugins/web/img/2.a24288e4.png";